<app-lifecycle-cards [leadId]="leadId" style="width: 100%;"></app-lifecycle-cards>
